"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createForm = createForm;
exports.DomForm = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _baseForm = require("./baseForm");

var _validateRules = require("./validateRules");

var _vnode = require("../../utils/vnode");

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DomForm = /*#__PURE__*/function (_BaseForm) {
  (0, _inherits2.default)(DomForm, _BaseForm);

  var _super = _createSuper(DomForm);

  function DomForm(context) {
    var _this;

    (0, _classCallCheck2.default)(this, DomForm);
    _this = _super.call(this);
    _this.context = void 0;
    _this.items = {};
    _this.context = context;
    return _this;
  }

  (0, _createClass2.default)(DomForm, [{
    key: "addField",
    value: function addField(name, context) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DomForm.prototype), "addField", this).call(this, name);

      if (context) {
        this.items[name] = context;
      }
    }
  }, {
    key: "removeField",
    value: function removeField(name) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DomForm.prototype), "removeField", this).call(this, name);
      delete this.items[name];
    }
  }, {
    key: "resetFields",
    value: function resetFields(names) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DomForm.prototype), "resetFields", this).call(this, names);
      this.forceUpdate(names);
    }
  }, {
    key: "setValues",
    value: function setValues(obj) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(DomForm.prototype), "setValues", this).call(this, obj);
      var names = Object.keys(obj);
      this.forceUpdate(names);
    }
  }, {
    key: "getValues",
    value: function getValues(names) {
      return (0, _utils.setDataByObj)({}, (0, _get2.default)((0, _getPrototypeOf2.default)(DomForm.prototype), "getValues", this).call(this, names));
    }
  }, {
    key: "validateFields",
    value: function validateFields(func, names) {
      var _this2 = this;

      var values = (0, _get2.default)((0, _getPrototypeOf2.default)(DomForm.prototype), "getValues", this).call(this, names);
      var errors = {};
      var validateList = []; // 生成校验 Promise 队列

      Object.keys(values).forEach(function (name) {
        var meta = _this2.getMeta(name);

        var rules = meta.rules;
        var validateFunc = (0, _validateRules.validateRules)(values[name], rules, 'submit').then(function (errs) {
          _this2.setMeta(name, {
            errors: errs
          });

          return {
            name: name,
            errs: errs
          };
        });
        validateList.push(validateFunc);
      }); // 批量校验

      Promise.all(validateList).then(function (errorList) {
        errorList.forEach(function (err) {
          if (err && err.errs && err.errs.length) {
            errors[err.name] = err.errs;
          }
        });

        _this2.forceUpdate();

        func(_this2.getValues(), Object.keys(errors).length ? errors : undefined);
      });
    }
  }, {
    key: "bindField",
    value: function bindField(name, options) {
      var _this3 = this;

      this.setMeta(name, options);
      return function (input) {
        var nodeProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _nodeProps$props = nodeProps.props,
            props = _nodeProps$props === void 0 ? {} : _nodeProps$props,
            _nodeProps$on = nodeProps.on,
            on = _nodeProps$on === void 0 ? {} : _nodeProps$on;

        var meta = _this3.getMeta(name);

        var trigger = meta.trigger;
        var initListeners = input.componentOptions && input.componentOptions.listeners;

        var newOn = _objectSpread({}, on); // 组件中注入事件监听


        newOn[trigger] = function () {
          if (on[trigger] && typeof on[trigger] === 'function') {
            // @ts-ignore
            on[trigger].apply(on, arguments);
          }

          _this3.addListenerOn(name, meta.getValueFromEvent).apply(void 0, arguments);
        };

        Object.keys(newOn).forEach(function (key) {
          if (initListeners && initListeners.hasOwnProperty(key)) {
            var initAction = newOn[key];

            newOn[key] = function () {
              // @ts-ignore
              initListeners[key].apply(initListeners, arguments); // @ts-ignore

              initAction.apply(void 0, arguments);
            };
          }
        }); // 组件注入组件的值

        var value = _this3.getValue(name);

        if (meta.normalize) {
          value = meta.normalize(value);
        }

        props[meta.valuePropName] = value;
        return (0, _vnode.cloneElement)(input, _objectSpread(_objectSpread({}, nodeProps), {}, {
          on: newOn,
          props: props
        }));
      };
    }
  }, {
    key: "addListenerOn",
    value: function addListenerOn(name, getValueFromEvent) {
      var _this4 = this;

      return function (e) {
        // 获取组件值
        var value = e;

        if (getValueFromEvent) {
          value = getValueFromEvent(e);
        } else if (e && e.target) {
          if (e.target.value !== undefined) {
            value = e.target.value;
          } else if (e.target.checked !== undefined) {
            value = e.target.checked;
          }
        } // 校验值


        (0, _validateRules.validateRules)(value, _this4.getMeta(name).rules, 'change').then(function (errs) {
          _this4.setMeta(name, {
            hasChange: true,
            errors: errs
          });

          _this4.forceUpdate([name]);
        }); // 设置组件值

        _this4.context.emitChange((0, _defineProperty2.default)({}, name, value));

        _this4.setValues((0, _defineProperty2.default)({}, name, value));
      };
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate(names) {
      if (!names) {
        names = Object.keys(this.items);
        this.context.$forceUpdate();
      }

      var items = this.items;
      names.forEach(function (c) {
        if (items[c] && items[c].$forceUpdate) {
          items[c].$forceUpdate();
        }
      });
    }
  }]);
  return DomForm;
}(_baseForm.BaseForm);

exports.DomForm = DomForm;

function createForm(context) {
  return Object.freeze(new DomForm(context));
}